import React from "react";
import { waLink } from "../../lib/api";
import { WhatsAppIcon } from "../WhatsAppIcon";

export const WhatsAppBanner = () => (
  <section className="relative py-12 sm:py-14 overflow-hidden" data-testid="whatsapp-banner-section">
    <img src="/whatsapp-banner.jpg" alt="" aria-hidden="true" className="absolute inset-0 w-full h-full object-cover object-center" />
    <div className="absolute inset-0 bg-maroon/85 mix-blend-multiply" />
    <div className="absolute inset-0 bg-gradient-to-r from-maroon-dark/70 via-maroon/40 to-transparent" />
    <div className="relative max-w-7xl mx-auto px-4 sm:px-6 flex flex-col lg:flex-row items-center justify-between gap-8">
      <div className="text-center lg:text-left">
        <h2 className="font-heading text-2xl sm:text-3xl lg:text-4xl tracking-tight font-medium text-ivory">Can't Decide? Talk to Us.</h2>
        <p className="text-ivory/70 mt-3 max-w-xl">
          Send us your favourite saree and our team will help you choose — fabric, colour, occasion and budget, all sorted over a quick chat.
        </p>
      </div>
      <a
        href={waLink("Namaste! I need help choosing a saree.")}
        target="_blank"
        rel="noreferrer"
        data-testid="whatsapp-banner-btn"
        className="inline-flex items-center gap-3 bg-[#25D366] text-white px-10 py-4 text-xs tracking-[0.2em] uppercase font-semibold hover:bg-[#1EBE5B] hover:-translate-y-0.5 transition-all whitespace-nowrap"
      >
        <WhatsAppIcon className="w-5 h-5" /> Chat on WhatsApp
      </a>
    </div>
  </section>
);
